/**
 * External dependencies
 */
import {
	ImageUploadPlaceholder, ColumnControl, URLInputControl, IconControl, IconDisplay 
} from '~cartzillagb/components'
import { srcUrl, i18n } from 'cartzillagb'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { withTabbedInspector, withUniqueClass } from '~cartzillagb/higher-order'
import classnames from 'classnames'

/**
 * Internal dependencies
 */
import DefaultImage  from  './img/default-avatar.png'

/**
 * Worpress dependencies
 */
import { RichText } from '@wordpress/block-editor'
import {
	PanelBody, RangeControl, TextControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { applyFilters,addFilter } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'



addFilter( 'cartzillagb.team-member.edit.inspector.style.before', 'czgb/team-member', ( output, props ) => {
	const { setAttributes, attributes } = props
	const {
		lgColumns,
		mdColumns,
		smColumns,
		limit,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'frontgb.team-member.edit.inspector.max.limit', 12 ) }
				/>
				<ColumnControl
					label={ __("Column Width", i18n ) }
					lgColumns={ lgColumns }
					lgMin={ 1 }
					lgMax={ 12 }
					mdColumns={ mdColumns }
					mdMin={ 1 }
					mdMax={ 12 }
					smColumns={ smColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangelg={ value => setAttributes( { lgColumns: value } ) }
					onChangemd={ value => setAttributes( { mdColumns: value } ) }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Icon Settings", i18n ) } initialOpen={ true }>
				<div className="icon-control-componet-wrapper">
					{ range( 1, limit + 1 ).map( i => {
						const mailicon = attributes[ `mailicon${ i }` ]
			
						let defaultmail =''

						if ( (i % 6 ) === 1 ) {
							defaultmail=__("johndoe@example.com", i18n )
						}

						if ( (i % 6 ) === 2 ) {               
							defaultmail=__("b.palson@example.com", i18n )
						}

						if ( (i % 6 ) === 3 ) {
							defaultmail=__("w.smith@example.com", i18n )

						}
						if ( (i % 6 ) === 4 ) {
							defaultmail=__("a.gallaher@example.com", i18n )
						}
						if ( (i % 6 ) === 5 ) {
							defaultmail=__("b.miller@example.com", i18n )
						}
						if ( (i % 6 ) === 0 ) {
							defaultmail=__("m.rodrigez@example.com", i18n )
						}


						return (
							<IconControl
								label={ __( `Link Icon ${ i }`, i18n ) }
								value={ mailicon || 'czi-mail' }
								onChange={ mailicon => setAttributes( { [ `mailicon${ i }` ]: mailicon } ) }
							/>
						)
					} ) }
				</div>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		lgColumns,
		smColumns,
		limit,
	} = attributes

	const mainClasses = classnames( [
		'row pt-3',
		className,
	], applyFilters( 'cartzillagb.team-member.main-block.classes', {}, props ) )

	const content = range( 1, ( limit ) + 1 ).map( i => {

		const defaultImg = `${ srcUrl }/${ DefaultImage }`
		let defaultname =''
		let defaultposition =''
		let defaultlinktext =''


		if ( (i % 6 ) === 1 ) {
			defaultname= (__('Jonathan Doe', i18n ))
			defaultposition= (__("CEO, Co-founder", i18n ))
			defaultlinktext=__("johndoe@example.com", i18n )
		}

		if ( (i % 6 ) === 2 ) {               
			defaultname= (__('Barbara Palson', i18n ))
			defaultposition= (__("Chief of Marketing", i18n ))
			defaultlinktext=__("b.palson@example.com", i18n )
		}

		if ( (i % 6 ) === 3 ) {
			defaultname= (__('William Smith', i18n ))
			defaultposition= (__("Financial director", i18n ))
			defaultlinktext=__("w.smith@example.com", i18n )

		}
		if ( (i % 6 ) === 4 ) {
			defaultname= (__('Amanda Gallaher', i18n ))
			defaultposition= (__("Lead UX designer", i18n ))
			defaultlinktext=__("a.gallaher@example.com", i18n )
		}
		if ( (i % 6 ) === 5 ) {
			defaultname= (__('Benjamin Miller', i18n ))
			defaultposition= (__("Website development", i18n ))
			defaultlinktext=__("b.miller@example.com", i18n )

		}
		if ( (i % 6 ) === 0 ) {
			defaultname= (__('Miguel Rodrigez', i18n ))
			defaultposition= (__("Content manager", i18n ))
			defaultlinktext=__("m.rodrigez@example.com", i18n )
		}

		const mediaURL = attributes[ `mediaURL${ i }` ]
		const name = attributes[ `name${ i }` ]
		const position = attributes[ `position${ i }` ]
		const linktext = attributes[ `linktext${ i }` ] !== undefined ? attributes[ `linktext${ i }` ]  : defaultlinktext
		const mailicon = attributes[ `mailicon${ i }` ]

		const imageComp = (
			<ImageUploadPlaceholder
				className={ `czgb-team-member__image` }
				imageURL={ mediaURL || defaultImg }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL || defaultImg } className="d-inline-block rounded-circle" width="96" alt={ __( 'team-member' ) } /> }
			/>
		)

		const nameComp = (
			<RichText
				tagName='h6'
				className="font-size-base pt-1 mb-1"
				value={ name || defaultname }
				onChange={ name => setAttributes( { [ `name${ i }` ]: name } ) }
				placeholder={ __( 'Name' ) }
				keepPlaceholderOnFocus
			/>
		)

		const positionComp = (
			<RichText
				tagName='p'
				value={ position || defaultposition }
				className="font-size-ms text-muted mb-0"
				onChange={ position => setAttributes( { [ `position${ i }` ]: position } ) }
				placeholder={ __( 'Position' ) }
				keepPlaceholderOnFocus
			/>
		)

		const linktextComp = (
			<RichText
				value={ linktext }
				onChange={ linktext => setAttributes( { [ `linktext${ i }` ]: linktext } ) }
				placeholder={ __( 'linktext' ) }
				keepPlaceholderOnFocus
			/>
		)

		const linkiconComp = (
			<IconDisplay 
				value={ mailicon || 'czi-mail' }
				additionalClass="mr-2"
			/>    
		)

		const bootstrapClass = getBootstrapClasses( undefined, smColumns, undefined, lgColumns )

		const output = (
			<div className={ `${ bootstrapClass } mb-grid-gutter` }  key={ i }>
				<div className="media align-items-center">
					{ imageComp }
					<div className="media-body pl-3">
						{ nameComp }
						{ positionComp }
						<span class="nav-link-style font-size-ms text-nowrap">{ linkiconComp }{ linktextComp }</span>
					</div>
				</div>
			</div>
		)

		return output
	} )

	return (
		<div className={ mainClasses }>
			{ content }
		</div>
	)
}

export default compose(
	withUniqueClass,
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )

